import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetCaracteristicaEspecial } from '../../shared/interfaces/database/evento';

@Injectable({
  providedIn: 'root'
})
export class CaracteristicaEspecialService {
  private readonly baseUrl = `${environment.apiUrl}/api/caracteristica-especial`;

  constructor(private http: HttpClient) { }

  getCaracteristicaEspecial(): Observable<IGetCaracteristicaEspecial[]> {
    return this.http.get<IGetCaracteristicaEspecial[]>(`${this.baseUrl}`);
  }
}
